import React from 'react';
import './PageFooter.css';

function PageFooter() {
  return (
    <footer className="page-footer">
      <div className="footer-divider"></div>
      <p className="footer-text">
        &copy; 2026 Publisearch Honduras. All rights reserved. All data, analyses, and content presented herein are the exclusive intellectual property of Publisearch Honduras. Reproduction, distribution, or use of this material, in whole or in part, without prior written consent from Publisearch Honduras is strictly prohibited. Publisearch Honduras is a Subsidiary of AdvanceTMS LLC
      </p>
    </footer>
  );
}

export default PageFooter;
